import script from "./CorridorTime.vue?vue&type=script&setup=true&lang=js"
export * from "./CorridorTime.vue?vue&type=script&setup=true&lang=js"

import "./CorridorTime.vue?vue&type=style&index=0&id=ea0e8494&lang=css"

const __exports__ = script;

export default __exports__